import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class InputHelper {
  checkLength(e, input, maxLength: number) {
    const functionalKeys = ['Backspace', 'ArrowRight', 'ArrowLeft']

    if (functionalKeys.indexOf(e.key) !== -1) {
      return
    }

    const keyValue = +e.key
    if (isNaN(keyValue)) {
      e.preventDefault()
      return
    }

    const hasSelection =
      input?.selectionStart !== input?.selectionEnd &&
      input?.selectionStart !== null
    let newValue
    if (hasSelection) {
      newValue = this.replaceSelection(input, e.key)
    } else {
      newValue = input.value + keyValue.toString()
    }

    if (+newValue > maxLength || newValue.length > 5) {
      e.preventDefault()
    }
  }

  private replaceSelection(input, key) {
    const inputValue = input.value
    const start = input?.selectionStart
    const end = input?.selectionEnd || input?.selectionStart
    return inputValue.substring(0, start) + key + inputValue.substring(end + 1)
  }
}
